import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PRODUCT } from '../../constants/queryKeys';
import { QueryOptions } from '../../types/query/useQuery';
import ProductApiV2 from '../../lib/api/product/ProductApiV2';
import { GetProductListRequest } from '../../lib/api/product/type';
import { ProductsResponseBodyDto } from '../../types/api/products';

type UseFetchProductListQuery<SelectResultType> = {
  payload: GetProductListRequest;
  options?: QueryOptions<ProductsResponseBodyDto, unknown, SelectResultType>;
};

export const useFetchProductListQuery = <SelectResultType>({
  payload,
  options,
}: UseFetchProductListQuery<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ProductsResponseBodyDto, unknown, SelectResultType>(
    [...PRODUCT.LIST, payload],
    () => ProductApiV2.getProductList(payload),
    options,
  );
};
